export const permissions = {
  organizationRead: 'organization:read',
  facilitiesRead: 'facility:read',
  facilitiesCreate: 'facility:create',
  machineRead: 'machine:read',
  machineCreate: 'machine:create',
  machineArchive: 'machine:archive',
  machineRestore: 'machine:restore',
  documentsRead: 'documents:read',
  documentsUpload: 'documents:upload',
  documentsReview: 'documents:review',
  documentsRemove: 'documents:remove',
  documentsRestore: 'documents:restore',
  conversationRead: 'conversation:read',
  conversationCreate: 'conversation:create',
  questionAsk: 'question:ask',
  investigationRead: 'investigation:read',
  investigationCreate: 'investigation:create',
  investigationUpdate: 'investigation:update',
  investigationContribute: 'investigation:contribute',
  investigationManageParticipants: 'investigation:manage_participants',
  usersRead: 'user:read',
  usersInvite: 'user:invite',
  usersAssignRole: 'user:assign_role',
  usersSuspend: 'user:suspend',
  usersReactivate: 'user:reactivate',
  usersRemove: 'user:remove',
  billingRead: 'billing:read',
  billingManage: 'billing:manage',
} as const;
